const chapterLanguages = {fin: 'fi', swe: 'sv', eng: 'en'};

export const chapterLanguage = language => chapterLanguages[language] || language;

const chapterApiLanguages = {fi: 'fin', sv: 'swe', en: 'eng'};

export const chapterApiLanguage = language => chapterApiLanguages[language] || language;